
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { ActivatedRoute, Params } from '@angular/router'

@Component({
    template: ` <router-outlet></router-outlet>`,
    styleUrls: ['./ESOA-form.component.scss']

})

export class ESOAFormExpiredComponent implements OnInit {
    constructor(private router: Router, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
       
        this.router.navigateByUrl('/soaformagentexpired')
        
    }


    
    }
